import {HttpParams} from '@angular/common/http';

import {TableFilterType, TableSortType} from '@ui/ui.module';
import {keys} from './general';

export interface IndexQueryStringType {
  sort?: TableSortType;
  page?: number;
  limit?: number;
  filter?: TableFilterType;
}

export function prepareIndexQueryString(queryString?: IndexQueryStringType) {
  const fromObject: { [param: string]: string } = {};

  if (queryString && queryString.sort) {
    fromObject.sort = JSON.stringify(queryString.sort);
  }
  if (queryString && queryString.limit) {
    fromObject.limit = JSON.stringify(queryString.limit);
  }
  if (queryString && queryString.page && queryString.limit) {
    fromObject.skip = JSON.stringify(queryString.limit * (queryString.page - 1));
  }
  if (queryString && queryString.filter && queryString.filter.rules.length > 0) {
    fromObject.filter = JSON.stringify(queryString.filter);
  }

  return fromObject;
}

export function generateIndexQueryString(queryString?: IndexQueryStringType) {
  const fromObject = prepareIndexQueryString(queryString);
  const headers = new HttpParams({
    fromObject,
  });

  return headers;
}

export function cleanNullableValue<T extends { [key: string]: any; }>(model: T, skipCheckProperties?: Array<keyof T>) {
  const cleanModel: Partial<T> = {};
  const isToSkip = (key: keyof T) => !!(skipCheckProperties && skipCheckProperties.find((p) => p === key));

  keys(model).forEach((key) => {
    if (model[key] !== null || isToSkip(key)) {
      cleanModel[key] = model[key];
    }
  });
  return cleanModel;
}

export function generatePlainQueryParamsFromObject<T extends { [key: string]: any; }>(obj: T) {
  return keys(obj).reduce((params, key) => {
    const value = (obj as any)[key];
    if (!value) {
      return params;
    }
    return `${String(params)}&${String(key)}=${JSON.stringify(value)}`;
  }, '');
}
